/* This module provides Route context */
import React, { useContext, createContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ROUTES, pathnames } from 'lib/routes';

const RouteContext = createContext({});

const RouteProvider = ({ children }) => {
  const location = useLocation();
  const history = useHistory();

  const getCurrentStep = () => {
    const currentStep = ROUTES[location.pathname] || ROUTES[pathnames.root];
    return currentStep;
  };

  const goToNextStep = (values) => {
    const currentStep = getCurrentStep();
    let nextStep = currentStep.next;

    // business info path for entities
    if (
      values.account_type === 'entity' &&
      location.pathname === pathnames.account_type
    ) {
      nextStep = pathnames.business_info;
    }

    // beneficial owner path for non-residents
    if (
      location.pathname === pathnames.beneficial_owner &&
      values.individual.address.country !== 'US'
    ) {
      nextStep = pathnames.beneficial_owner_contact_info;
    }

    // skip ecp status if not applicable
    if (
      nextStep === pathnames.ecp_status &&
      !values.can_be_ecp
    ) {
      nextStep = pathnames.complete_application;
    }

    if (
      location.pathname === pathnames.account_type &&
      (values.individual && values.individual.persona_inquiry_status === 'completed') &&
      (values.registration_revoked === null ||
        values.convicted_felon === null ||
        values.misdemeanor === null ||
        values.under_investigation === null)
    ) {
      nextStep = pathnames.background_info;
    }

    history.push(nextStep + location.search);
  };

  const contextValue = {
    getCurrentStep,
    goToNextStep,
  };

  return (
    <RouteContext.Provider value={contextValue}>
      {children}
    </RouteContext.Provider>
  );
};

export const useRoute = () => useContext(RouteContext);

export default RouteProvider;
